<div class="dropdown">
  <app-icon tooltip="Download Chart" [icon]="'DOWNLOAD'" [iconSize]="'1.3rem'" data-bs-toggle="dropdown">
  </app-icon>
  <ul class="dropdown-menu" style="padding-left: 1rem">
    <li class="pointer downloadmenu" (click)="downloadImage()">
      <app-icon [color]="'skyblue'" [icon]="'IMAGE'"></app-icon><a class="dropdown-item">Image</a>
    </li>
    <li class="pointer downloadmenu" (click)="downloadHTMLAsPDF()">
      <app-icon [color]="'red'" [icon]="'FILE_COPY'"></app-icon><a class="dropdown-item">PDF</a>
    </li>
  </ul>
</div>